import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { weekOverview } from "@features/programs/utils/gamification";
import { WeekRing } from "./WeekRing";
import { WeekDays } from "./WeekDays";
import { StarIcon, ClockIcon } from "./icons";
import "./gamification.css";

/**
 * The card above the program list: this week across every active program —
 * the ring, the seven days, the streak, and one line saying what is left.
 * Renders nothing while the patient has no active program.
 */
export function WeekBand({ programs, now = null }) {
  const { t } = useTranslation();
  const week = useMemo(() => weekOverview(programs, now || new Date()), [programs, now]);

  if (!week.programCount || !week.goal) return null;

  const hint = week.complete
    ? t("gamification.week.hint_complete")
    : t("gamification.week.hint_open", { count: week.remaining });

  return (
    <section className="gm gm-card" aria-label={t("gamification.week.title")}>
      <div className="gm-band">
        <WeekRing done={week.done} goal={week.goal} label={t("gamification.week.units")} />

        <div className="gm-band-body">
          <h2 className="gm-band-title">{t("gamification.week.title")}</h2>
          <WeekDays days={week.days} />
          <p className="gm-band-sub">
            {t("gamification.week.programs", { count: week.programCount, goal: week.goal })}{" "}
            {t("gamification.week.dots_hint")}
          </p>
        </div>

        <div className="gm-streak">
          <span className="gm-streak-l">{t("gamification.streak.label")}</span>
          <span className="gm-streak-val">
            <StarIcon />
            <span className="gm-streak-num">{week.streak}</span>
          </span>
          <span className="gm-streak-note">{t("gamification.streak.weeks", { count: week.streak })}</span>
        </div>
      </div>

      <p className="gm-hint">
        <ClockIcon />
        {hint}
      </p>
    </section>
  );
}

export default WeekBand;
